export default "__VITE_ASSET__f99a2d17__"